<template>
	<div class="content">
		<div class="content_head">
			<p>
				<button type="button" @click="$router.go(-1)" class="button">返回</button>
				<hr />
			</p>
			<p>
				<span v-if="order!=null" class="red">

					订单编号:{{order.OrderCode }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					借书数量:{{order.BookNums }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					客户信息:{{order.CustomerName +' '+ order.CustomerPhone}}
					&nbsp; &nbsp; &nbsp;&nbsp;
					收货地址:{{order.Destination }}
					&nbsp; &nbsp; &nbsp;&nbsp;
					订单时间:{{order.OrderDate }}
				</span>
			</p>
			<p>
				<hr style="color: blue;" />
			</p>
		</div>
		<div class="content_body">
			<div style="padding-top: 1rem;">
				<p>
					<input type="text" placeholder="书籍编码|或者扫描书籍二维码" @keypress="searchBook" class="search"
						v-model="searchBookCode" />
					<button type="button" class="button" :disabled="searchBookCode.length<8" @click="getBook()"
						title="点击进行查找">查找书籍</button>
				</p>
			</div>
			<div>
				<table>
					<thead>
						<tr>
							<td>序号</td>
							<th>书籍名称</th>
							<th>移除书籍</th>
							<th>借出数量</th>
							<td style="width: 30rem;">
								图书详情
							</td>

						</tr>
					</thead>
					<tbody>
						<tr v-for="(i,index_i) in books">
							<td>{{index_i+1}}</td>
							<td>
								<img :src="$store.state.imageUrl+i.ImageName"
									style="height: 5rem;width: auto;padding: .5rem;" />
								{{i.BooksName}}
								<span class="red">推荐位置:{{i.CurrentPlace}}</span>

							</td>
							<td>
								<button type="button" @click='deleteBooks(i,index_i)' class="button">移除书籍</button>
							</td>
							<td>
								{{i.BooksCount}}
							</td>
							<td>
								<p v-for="(y,index_y) in i.books" class="borrowBooks">
									编号: <span class="red"> {{ y.BooksNumCode}} </span>位置:<span
										class="red">{{y.ShopName+' ' +y.CurrentPlace}}</span>
									<button type="button" @click='removeBook(index_i,index_y)'
										class="button">移除</button>
								</p>
							</td>
						</tr>

					</tbody>
				</table>

			</div>

		</div>
		<p style="text-align: right; color:  red;font-size: 1.3rem;">
			{{borrowCountSum}}
			<button class="button" @click="borrowBooks">提交</button>
		</p>
	</div>

</template>

<script>
	export default {
		name: 'borrowOrderDetail',
		data() {
			return {
				order: null,
				searchBookCode: '',
				getBook: {},
				books: [],
				borrowCount: 0,
				OperatorID: this.$store.state.user.UserID,
				ShopID: this.$store.state.user.ShopID,
				orderID: 0,
				getData: {}
			}
		},
		created() {
			this.getData = () => {
				this.orderID = this.$route.params.orderID;
				this.$request.request({
					url: 'weChatOrder/getOrderByOrderID',
					data: {
						OrderID: this.orderID
					},
					method: 'post'
				}).then(res => {
					if (res.result) {
						this.order = res.order;
						this.books = res.order.books;
					} else {
						this.$uil.showMessage({
							text: res.message
						});
					}
				})
			}
			this.getData();
			this.getBook = function() {
				if (this.order == null) {
					this.$uil.showMessage({
						text: '请先确认会员信息'
					});
					return;
				}
				this.$request.request({
					url: 'borrowAndReturn/getBookByBookCode',
					data: {
						searchText: this.searchBookCode.trim()
					},
					method: 'post'
				}).then(res => {
					if (res.result) {
						let book = res.book;
						if (book.BooksSate == 2) {
							this.$uil.showMessage({
								text: '该书已经借出'
							});
							this.searchBookCode = '';
							return;
						}
						for (let i of this.books) {
							if (i.BooksID == book.BooksID) {
								for (let j of i.books) {
									if (j.BorrowOutBookDetailID == book.BookDetailID) {
										this.$uil.showMessage({
											text: '该书已经添加至借书单'
										});
										this.searchBookCode = '';
										return;
									}
								}
								if (i.BooksCount == i.books.length) {
									this.$uil.showMessage({
										text: '不得超过借书数量'
									});
									this.searchBookCode = '';
									return;
								}

								i.books.push({
									'BorrowOutBookDetailID': book.BookDetailID,
									'BooksNumCode': book.BooksNumCode,
									'ShopID': book.ShopID,
									'ShopName': book.ShopName,
									'CurrentPlace': book.CurrentPlace,
									'CustomerOrderBooksDetailID': 0
								});
								break;
							}
						}

						this.searchBookCode = '';
					} else {
						this.$uil.showMessage({
							text: res.message
						});
					}
				})


			}
		},
		methods: {
			searchBook(e) {
				if (e.keyCode == 13)
					this.getBook()();
			},
			removeBook(index_i, index_y) {
				let CustomerOrderBooksDetailID = this.books[index_i].books[index_y].CustomerOrderBooksDetailID;
				if (CustomerOrderBooksDetailID > 0) {
					this.$request.request({
						url: 'weChatOrder/removeBooks',
						data: {
							OrderID: this.orderID,
							CustomerOrderBooksDetailID: CustomerOrderBooksDetailID,
							ShopID: this.ShopID,
							OperatorID: this.OperatorID,
						},
						method: 'post'
					}).then(res => {
						if (res.result)
							this.books[index_i].books.splice(index_y, 1);
						else
							this.$uil.showMessage({
								text: res.message
							});
					});
				} else
					this.books[index_i].books.splice(index_y, 1);
			},
			borrowBooks() {
				let borrowBook = [];
				for (let i of this.books) {
					for (let j of i.books) {
						if (j.CustomerOrderBooksDetailID == 0) {
							borrowBook.unshift({
								CustomerOrderBooksID: i.CustomerOrderBooksID,
								BorrowOutBookDetailID: j.BorrowOutBookDetailID
							})

						}
					}
				}

				this.$request.request({
					url: 'weChatOrder/borrowBooksDetail',
					data: {
						OrderID: this.orderID,
						ShopID: this.ShopID,
						OperatorID: this.OperatorID,
						borrowBook: JSON.stringify(borrowBook),
					},
					method: 'post'

				}).then(res => {

					this.$uil.showMessage({
						text: res.message
					});
					if (res.result)
						this.$router.go(-1);
				});

			},
			deleteBooks(i, index) {
				 
				this.$uil.showMessage({
					'text': '确定删除',
					'type': 'confirm',
					ok: () => {
						this.$request.request({
							url: 'weChatOrder/removebook',
							data: {
								CustomerOrderBooksID: i.CustomerOrderBooksID
							},
							method: 'post'

						}).then(res => {

							this.$uil.showMessage({
								text: res.message
							});
							 
							if (res.result) {
								this.books.splice(index, 1);
							}
						});
					}
				})

			}
		},
		computed: {
			borrowCountSum() {
				let sum = 0;
				for (let i of this.books) {
					for (let j of i.books) {
						if (j.CustomerOrderBooksDetailID == 0) sum++;
					}
				}
				return '本次配书:' + sum + '本';

			}

		},
		watch: {
			$route(n, o) {
				if (n.path.indexOf('borrowOrderDetail') == -1) return;
				let nbooksid = n.params.orderID;
				let obooksid = o.params.orderID;
				if (nbooksid != obooksid)
					this.getData();
			}

		}

	}
</script>

<style>
</style>
